import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 0,
    tagCount: 0,
    //  isSignIn 登录状态，0为未登录
    isSignIn: 0,
    loginName: '',
    token: '',
    // 请求打开 Contact Me 私信弹窗（由通知铃触发，banner 组件监听）
    // 结构：{ userId, userName, t }，t 用于保证每次点击都能触发 watch
    contactMeRequest: null,

  },
  mutations: {
    changIsSignIn(state, n) {
      state.isSignIn = n;
    },
    setContactMeRequest(state, val) {
      state.contactMeRequest = val;
    },
    setToken(state, val) {
      state.token = val;
    },
    setLoginName(state, val) {
      state.loginName = val;
    },
    setCount(state, val) {
      state.count = val
    },
    setTagCount(state, val) {
      state.tagCount = val
    },
  },
  actions: {
  },
  modules: {
  }
})

    